import { OptimizelyProvider } from '@optimizely/react-sdk';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { identify } from 'analytics/frontend';
import Footer from 'components/Footer';
import Header from 'components/Header';
import UserContext from 'contexts/User';
import Routes from 'routes';
import authenticate from 'services/auth';
import trackReferralProfile from 'services/referralProfile';
import optimizely from 'utils/optimizely';

function App() {
  const [loading, setLoading] = useState(true);
  const [uuid, setUuid] = useState('');

  useEffect(() => {
    authenticate()
      .then((_uuid) => {
        console.log(`UUID: ${_uuid}`);
        setUuid(_uuid);
        trackReferralProfile();
        identify(_uuid);
        window.traits = { uuid: _uuid };
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Helmet defaultTitle="Policygenius | Disability Insurance" />
      <UserContext.Provider value={{ uuid }}>
        <OptimizelyProvider optimizely={optimizely} user={{ id: uuid }}>
          <Header />
          <Routes loading={loading} />
          <Footer />
        </OptimizelyProvider>
      </UserContext.Provider>
    </>
  );
}

export default App;
